import {injectable} from 'inversify-props';
import Axios, {AxiosInstance} from 'axios';

import * as yaml from 'js-yaml';
// @ts-ignore
import semver from 'semver';

import {FeedChannelRelease, FeedInfo} from '@/model/system/update/Feed';

import {ISystemUpdateService} from '@/services/system/IUpdate.service';
import {ReleaseInfo} from '@/model/system/update/Release';

@injectable()
export class SystemUpdateService implements ISystemUpdateService {

  public static ArtifactExtension = 'mender';
  public static FeedInfoFileName = 'feed.yml';

  private httpService: AxiosInstance = Axios.create({
    timeout: 5000,
  });

  public async isUpdateAvailable(releaseInfo: ReleaseInfo, currentVersion: string): Promise<boolean> {
    return semver.lt(currentVersion, releaseInfo.version);
  }

  public async isUpgradable(currentVersion: string, releaseInfo: ReleaseInfo) {
    if (!releaseInfo.upgradeCondition || releaseInfo.upgradeCondition === '') {
      return true;
    }

    return semver.satisfies(currentVersion, releaseInfo.upgradeCondition);
  }

  public async getFeedInfo(basePath: string, args: Map<string, string> = new Map<string, string>()): Promise<FeedInfo> {

    const requestArgs = [];

    if (!args.has('timestamp')) {
      args.set('timestamp', `${new Date().getTime()}`);
    }

    for (const [name, value] of args.entries()) {
      requestArgs.push(`${name}=${value}`);
    }

    const channelInfoFilePath = `${basePath}/${SystemUpdateService.FeedInfoFileName}?${requestArgs.join('&')}`;

    const channelInfoFile = await this.httpService.get(channelInfoFilePath, {
      responseType: 'blob',
    });

    switch (channelInfoFile.status) {
      case 200:
        const blob = new Blob([channelInfoFile.data], {type: 'text/plain'});

        return new Promise<FeedInfo>((resolve, reject) => {
          const reader = new FileReader();

          reader.onload = (event: any) => {
            const data = event.target.result;

            try {
              const feedInfo = new FeedInfo(yaml.safeLoad(data));
              resolve(feedInfo);
            } catch (error) {
              reject(error);
            }
          };
          reader.readAsText(blob);
        });

      default:
        throw new Error('could not get channel info');
    }
  }

  public async getReleaseInfo(releasePath: string, args: Map<string, string> = new Map<string, string>()): Promise<ReleaseInfo> {

    const requestArgs = [];

    if (!args.has('timestamp')) {
      args.set('timestamp', `${new Date().getTime()}`);
    }

    for (const [name, value] of args.entries()) {
      requestArgs.push(`${name}=${value}`);
    }

    const releaseInfoFilePath = `${releasePath}/release.yml?${requestArgs.join('&')}`;

    const response = await this.httpService.get(releaseInfoFilePath, {
      responseType: 'blob',
    });

    switch (response.status) {
      case 200:
        const blob = new Blob([response.data], {type: 'text/plain'});

        return new Promise<ReleaseInfo>((resolve, reject) => {
          const reader = new FileReader();

          reader.onload = (event: any) => {
            const data = event.target.result;

            try {
              const releaseInfo = new ReleaseInfo(yaml.safeLoad(data));
              resolve(releaseInfo);
            } catch (error) {
              reject(error);
            }
          };
          reader.readAsText(blob);
        });

      default:
        throw new Error(`could not get release info (${response.statusText})`);
    }
  }


  // public async getChannelInfoOnline(basePath: string, channelName: string): Promise<FeedChannel> {
  //   return new Promise<FeedChannel>((resolve, reject) => {
  //
  //     const feedInfoRequest = this.getFeedInfo(basePath);
  //
  //     feedInfoRequest.then((feedInfo: FeedInfo) => {
  //       resolve(this.getChannelInfo(feedInfo, channelName));
  //     }).catch((error) => reject(error));
  //   });
  // }
  //
  // public getChannelInfo(feedInfo: FeedInfo, channelName: string): FeedChannel {
  //
  //   for (const channel of feedInfo.channels) {
  //     if (channel.name === channelName) {
  //       return channel;
  //     }
  //   }
  //
  //   throw new Error(`Could not find channel '${channelName}'`);
  // }
  //
  // public async getReleaseInfoOnline(basePath: string, channelName: string, machine: string): Promise<FeedChannelRelease> {
  //   return new Promise<FeedChannelRelease>((resolve, reject) => {
  //
  //     const channelPromise = this.getChannelInfoOnline(basePath, channelName);
  //
  //     channelPromise.then((channelInfo: FeedChannel) => {
  //       resolve(this.getReleaseInfo(channelInfo, channelName, machine));
  //     }).catch((error) => reject(error));
  //   });
  // }
  //
  // public getReleaseInfo(channelInfo: FeedChannel, channelName: string, machine: string): FeedChannelRelease {
  //
  //   for (const release of channelInfo.releases) {
  //     if (release.machines.includes(machine)) {
  //       return release;
  //     }
  //   }
  //
  //   throw new Error(`Could not find a release for '${channelName}'`);
  // }
}
